<template>
  <div v-if="scaleFee">
    <h1>Scale fee</h1>
    <v-btn :to="{name:'scales'}">
      <v-icon>chevron_left</v-icon>Scales
    </v-btn>
    <v-btn @click="deleteScaleFee()" v-if="$keycloak.hasRealmRole('root')" color="error">
      <v-icon>delete</v-icon>Delete
    </v-btn>
    <v-btn
      :to="{name:'scaleFeeType', params:{id:scaleFee.scalefeetypeid}}"
      v-if="computedScaleFeeType"
    >
      <span>Scale fee type:&#160;</span>
      <span>{{computedScaleFeeType.name}}</span>
    </v-btn>
    <div v-if="!$route.params.id">
      <v-form ref="formScaleFee" v-model="valid" lazy-validation>
        <v-select
          label="Scale fee type"
          v-model="scaleFee.scalefeetypeid"
          :items="scaleFeeTypes"
          item-value="id"
          item-text="name"
          outline
          :rules="valueRules"
        ></v-select>
        <v-btn @click="saveScaleFee">
          <v-icon>save</v-icon>Save
        </v-btn>
      </v-form>
    </div>
    <div v-if="$route.params.id">
      <h3>Scale items</h3>
      <ScaleFeeEdit :id="$route.params.id" />
    </div>
  </div>
</template>

<script>
import ScaleFeeEdit from "@/components/quote/scales/ScaleFeeEdit";
import nbmlaw from "@/api/nbmlaw";
import { convertListOfObjectsToMap } from "@/util/helpers";
export default {
  name: "ScaleFee",
  metaInfo() {
    return {
      title: "Scale fee",
      titleTemplate: "%s - Sales - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: { ScaleFeeEdit },
  computed: {
    computedScaleFeeType() {
      if (!this.$route.params.id || !this.scaleFee) {
        return undefined;
      }
      const scaleFeeTypesMap = this.scaleFeeTypes
        ? convertListOfObjectsToMap(this.scaleFeeTypes, "id")
        : undefined;
      return scaleFeeTypesMap
        ? scaleFeeTypesMap[this.scaleFee.scalefeetypeid]
        : undefined;
    }
  },
  data() {
    return {
      scaleFee: null,
      scaleFeeTypes: null,
      valueRules: [v => !!v || "Value is required"],
      valid: false
    };
  },
  methods: {
    fetchScaleFee() {
      nbmlaw
        .get(`/cors/admin/sales/scaleFees/${this.$route.params.id}`)
        .then(response => {
          // console.log(response.data);
          this.scaleFee = response.data;
        });
    },
    fetchScaleFeeTypes() {
      nbmlaw.get(`/cors/admin/sales/scaleFeeTypes`).then(response => {
        // console.log(response.data);
        this.scaleFeeTypes = response.data;
      });
    },
    saveScaleFee() {
      if (this.$refs.formScaleFee.validate()) {
        nbmlaw
          .post(`/cors/admin/sales/scaleFees`, this.scaleFee)
          .then(response => {
            // console.log(response.data);
            this.$router.push({
              name: "scaleFee",
              params: { id: response.data }
            });
          });
      }
    },
    deleteScaleFee() {
      if (confirm("Are you sure?")) {
        nbmlaw
          .delete(`/cors/admin/sales/scaleFees/${this.$route.params.id}`)
          .then(() => {
            // console.log(response.data);
            this.$router.push({ name: "scales" });
          });
      }
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        if (this.$route.params.id) {
          this.fetchScaleFee();
        } else {
          this.scaleFee = {};
        }
      }
    }
  },
  created() {
    this.fetchScaleFeeTypes();
  }
};
</script>